import { Component, OnInit } from '@angular/core';
import { CommonDataService } from '../../../common/services/common-data.service';
import { GraphqlService } from '../../../common/services/graphql.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { UtilityService } from '../../../common/services/utility-service';
import { constObj } from '../../../common/Constants/constants';
import { ConfirmDialogComponent } from '../../../common/shared-components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-help-glossary-term-finder',
  templateUrl: './help-glossary-term-finder.component.html'
})
export class HelpGlossaryTermFinderComponent implements OnInit {

  constructor(
    public commonDataService: CommonDataService,
    private graphQlService: GraphqlService,
    private router: Router,
    public dialog: MatDialog,
    private utilityService: UtilityService) {
    this.isArchiveApplication();
  }
  archiveVersion: string = "";
  isArchive: boolean = false;
  help_glossaryHeader;
  help_glossaryDescription;
  help_glossarysubheader1;
  help_glossarysubheader2;
  help_glossarysubheader3;
  help_glossarysubheader4;
  help_glossarysubtext1;
  help_glossarysubtext2;
  help_glossarysubtext3
  help_glossarysubtext4

  ngOnInit(): void {
    this.commonDataService.showLoader.next(true);
    this.gethelpglossarytermfinderlabels();
  }
  ngOnDestroy() {
    this.commonDataService.loadCurrentLeftNav.next(null);
  }

  gethelpglossarytermfinderlabels() {
    this.graphQlService.getHelpGlossaryTermFinderComponentLabel().subscribe(data => {
      if (data != "") {
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.help_glossaryHeader = labels.filter(x => x.key == "help_glossaryHeader").map(y => y.value);
        this.help_glossaryDescription = labels.filter(x => x.key == "help_glossaryDescription").map(y => y.value);
        this.help_glossarysubheader1 = labels.filter(x => x.key == "help_glossarysubheader1").map(y => y.value);
        this.help_glossarysubtext1 = labels.filter(x => x.key == "help_glossarysubtext1").map(y => y.value);
        this.help_glossarysubheader2 = labels.filter(x => x.key == "help_glossarysubheader2").map(y => y.value);
        this.help_glossarysubtext2 = labels.filter(x => x.key == "help_glossarysubtext2").map(y => y.value);
        this.help_glossarysubheader3 = labels.filter(x => x.key == "help_glossarysubheader3").map(y => y.value);
        this.help_glossarysubtext3 = labels.filter(x => x.key == "help_glossarysubtext3").map(y => y.value);
        this.help_glossarysubheader4 = labels.filter(x => x.key == "help_glossarysubheader4").map(y => y.value);
        this.help_glossarysubtext4 = labels.filter(x => x.key == "help_glossarysubtext4").map(y => y.value);
        this.commonDataService.showLoader.next(false);
      }
    });
  }
  isArchiveApplication() {
    this.archiveVersion = localStorage.getItem("ArchiveVersion");
    if (localStorage.getItem("publicationId") != undefined && localStorage.getItem("currentVersionPublicationId") != localStorage.getItem("publicationId")) {
      this.archiveVersion = this.utilityService.convertMonthYear(localStorage.getItem("ArchiveVersion"));
      this.isArchive = Boolean(this.archiveVersion);
    }
    else if (this.router.url.split("/")[1] != localStorage.getItem("currentVersionPublicationId") && (this.archiveVersion != null && this.archiveVersion != undefined)) {
      this.archiveVersion = localStorage.getItem("ArchiveVersion");
      this.isArchive = Boolean(this.archiveVersion);
    }
    else { this.isArchive = false; }
  }
  BackToCurrentContent() {
    const PrintQueueSession = localStorage.getItem("SetPrintQueueSession");
    var printQueueCount: any = PrintQueueSession == "{}" ? 0 : PrintQueueSession == null ? 0 : PrintQueueSession == "" ? 0 : JSON.parse(localStorage.getItem("SetPrintQueueSession")).ParagraphIdsList.length;
    let popUpMessage = constObj.currentVersionNavigationAlert;
    if (printQueueCount > 0) {
      popUpMessage += "<br/>" + constObj.annotationAlertPrintQueue;
    }
    else { popUpMessage += "<br/>" + constObj.continueMessage; }
    localStorage.setItem("isConfirmPopup", "true");
    this.commonDataService.isConfirmationPopUpOpen.next(true);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '600px',
      data: popUpMessage
    });
    dialogRef.afterClosed().subscribe((result: boolean) => {
      localStorage.removeItem("isConfirmPopup");
      if (result == true) {
        this.commonDataService.resetPrintQueue.next(true);
        this.commonDataService.printCount.next("toggleOff");
        this.commonDataService.printToggleOff.next("printToggleOff");
        localStorage.removeItem("ArchiveVersion");
        this.commonDataService.loadCurrentLeftNav.next(localStorage.getItem("currentVersionPublicationId"));
        this.router.navigateByUrl("/Home")
      }
    });
  }
}
